module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4 pb-5",
    attrs: {
      "height": "100%"
    }
  }, [_c('a', {
    attrs: {
      "id": ("space-" + _vm.serviceId)
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.requests.space
    },
    on: {
      "ok": function($event) {
        _vm.edittitle = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.backgroundDialog),
      callback: function($$v) {
        _vm.backgroundDialog = $$v
      },
      expression: "backgroundDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        Choose a background picture\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.backgroundDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('image-search', {
    attrs: {
      "title": "Search for an image"
    },
    on: {
      "input": _vm.saveBackground
    },
    model: {
      value: (_vm.settings.background_picture),
      callback: function($$v) {
        _vm.$set(_vm.settings, "background_picture", $$v)
      },
      expression: "settings.background_picture"
    }
  })], 1)], 1), _vm._v(" "), (_vm.settings && _vm.settings.background_picture) ? _c('v-img', {
    attrs: {
      "height": "250",
      "src": _vm.settings.background_picture
    }
  }, [_c('v-card-title', {
    staticClass: "title pl-4 white--text",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.6)"
    }
  }, [(_vm.edittitle) ? _c('v-text-field', {
    attrs: {
      "dark": "",
      "loading": _vm.requests.space.loading,
      "append-icon": "save"
    },
    on: {
      "blur": _vm.saveTitle,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveTitle.apply(null, arguments)
      },
      "click:append": _vm.saveTitle
    },
    model: {
      value: (_vm.service.title),
      callback: function($$v) {
        _vm.$set(_vm.service, "title", $$v)
      },
      expression: "service.title"
    }
  }) : _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.edittitle = true
      }
    }
  }, [_vm._v(_vm._s(_vm.service.title) + "\n\n        "), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.expand) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.expand = true;
        _vm.$vuetify.goTo(("#space-" + (_vm.service.id) + "-settings"))
      }
    }
  }, [_vm._v("Edit")]) : _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.expand = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "absolute": "",
      "bottom": "",
      "right": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.backgroundDialog = true
      }
    }
  }, [_vm._v("\n      Click to change background picture\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.logoDialog),
      callback: function($$v) {
        _vm.logoDialog = $$v
      },
      expression: "logoDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        Update your Logo\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.logoDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('uploader', {
    attrs: {
      "upload-path": _vm.logoUploadPath,
      "filename": "logo_picture"
    },
    on: {
      "uploadsuccess": function($event) {
        _vm.reload();
        _vm.logoDialog = false
      }
    },
    scopedSlots: _vm._u([{
      key: "gallery",
      fn: function(props) {
        return [_c('v-subheader', [_vm._v("Examples of how this may look in various places")]), _vm._v(" "), _vm._l((props.images), function(img, index) {
          return _c('v-layout', {
            key: index
          }, [_c('v-flex', [_c('v-subheader', [_vm._v("Avatar view")]), _vm._v(" "), _c('v-avatar', [_c('img', {
            attrs: {
              "src": img
            }
          })])], 1), _vm._v(" "), _c('v-flex', [_c('v-subheader', [_vm._v("Normal view")]), _vm._v(" "), _c('img', {
            attrs: {
              "src": img
            }
          })], 1)], 1)
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.settings) ? _c('v-card-text', {
    staticClass: "mb-3",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', [_c('strong', [_vm._v("Practice name")]), _vm._v(" " + _vm._s(_vm.settings.practice_name))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Practice number")]), _vm._v(" " + _vm._s(_vm.settings.practice_number))])]) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "ml-4 elevation-10 align-end",
    staticStyle: {
      "margin-top": "-220px"
    },
    attrs: {
      "absolute": "",
      "width": "200",
      "height": "180"
    },
    on: {
      "click": function($event) {
        _vm.logoDialog = true
      }
    }
  }, [(_vm.settings.logo_picture) ? [_c('v-img', {
    attrs: {
      "src": _vm.settings.logo_picture,
      "height": "150",
      "max-width": "200",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-footer', {
    staticClass: "caption justify-center ma-0",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.6)"
    },
    attrs: {
      "tile": "",
      "dark": ""
    }
  }, [_vm._v("\n          Click to edit logo\n        ")])] : _c('v-card-text', {
    staticClass: "pt-5 subheading"
  }, [_c('center', [_c('v-icon', [_vm._v("image")]), _c('br'), _vm._v("\n          Click to upload a logo\n        ")], 1)], 1)], 2), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.invoicesettingsDialog),
      callback: function($$v) {
        _vm.invoicesettingsDialog = $$v
      },
      expression: "invoicesettingsDialog"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.requests.service.settings
    },
    on: {
      "ok": function($event) {
        _vm.reload();
        _vm.invoicesettingsDialog = false
      }
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        Invoice settings\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.invoicesettingsDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('invoice-settings', {
    attrs: {
      "space-id": _vm.spaceId,
      "loading": _vm.requests.service.settings.loading
    },
    on: {
      "input": _vm.saveSettings,
      "close": function($event) {
        _vm.invoicesettingsDialog = false
      }
    },
    model: {
      value: (_vm.settings),
      callback: function($$v) {
        _vm.settings = $$v
      },
      expression: "settings"
    }
  })], 1)], 1), _vm._v(" "), _c('a', {
    attrs: {
      "id": ("space-" + (_vm.service.id) + "-settings")
    }
  }), _vm._v(" "), (_vm.settings) ? [_c('v-subheader', {
    staticClass: "overline mt-5"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "accent"
    }
  }, [_vm._v("post_add")]), _vm._v("\n      Invoice details\n      "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mx-3",
    attrs: {
      "id": ("service-" + (_vm.service.id) + "-invoice-settings")
    },
    on: {
      "click": function($event) {
        _vm.invoicesettingsDialog = true
      }
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.service.settings
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.invoicesettingfields), function(field) {
    return _c('v-flex', {
      key: field,
      staticClass: "mt-2",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md3": ""
      }
    }, [_c('strong', {
      domProps: {
        "textContent": _vm._s(field.replace("_", " "))
      }
    }), _vm._v(" "), _c('pre', {
      staticClass: "caption",
      domProps: {
        "textContent": _vm._s(_vm.settings[field])
      }
    })])
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "small": ""
    }
  }, [_vm._v("Edit")])], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "accent"
    }
  }, [_vm._v("paid")]), _vm._v("\n    Payments\n  ")], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mx-3"
  }, [_c('v-card-actions', [_c('img', {
    attrs: {
      "src": "https://dropbox-appointmentguru.s3.eu-central-1.amazonaws.com/yoco.jpeg",
      "height": "50"
    }
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": _vm.yocoIntegrationLink
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Accept payments with Yoco")]), _vm._v(" "), (_vm.yocoIntegrationLink) ? _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.yocoIntegrationLink))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.yocoIntegration && _vm.yocoIntegration.id) ? [_c('v-chip', {
    staticClass: "mr-3",
    attrs: {
      "color": "success",
      "dark": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check_circle")]), _vm._v("\n          Configured\n        ")], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.configureYocoDialog = true
      }
    }
  }, [_vm._v("Edit")])] : [_c('v-btn', {
    attrs: {
      "href": "https://referral.yoco.com/32Tzfb",
      "target": "_blank"
    }
  }, [_vm._v("\n          Open a free Yoco account\n          "), _c('v-icon', [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.configureYocoDialog = true
      }
    }
  }, [_vm._v("Configure")])]], 2), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.configureYocoDialog),
      callback: function($$v) {
        _vm.configureYocoDialog = $$v
      },
      expression: "configureYocoDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n          Configure Yoco\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.configureYocoDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.configureYocoDialog) ? _c('yoco', {
    attrs: {
      "space-id": _vm.serviceId
    },
    on: {
      "ok": function($event) {
        return _vm.$emit('reload')
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.settings && (_vm.yocoIntegration && _vm.yocoIntegration.id)) ? _c('v-footer', [(_vm.settings.payment_invoices_visible) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Show on invoices\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.settings.payment_appointments_visible) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Show on appointment page\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.settings.payment_appointments_prepayments) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Allow pre-payments\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.settings.payment_appointments_only_if_invoiceable) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Only show if appointment marked as invoiceable\n      ")], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-2"
  }, [(!_vm.expand) ? [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.expand = true
      }
    }
  }, [_vm._v("More details\n        "), _c('v-icon', [_vm._v("expand_more")])], 1), _vm._v(" "), (_vm.service && _vm.service.addresses) ? _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "outline": ""
    }
  }, [_vm._v(_vm._s(_vm.service.addresses.length) + " locations")]) : _vm._e(), _vm._v(" "), (_vm.service && _vm.service.products) ? _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "outline": ""
    }
  }, [_vm._v(_vm._s(_vm.service.products.length) + " appointment types")]) : _vm._e()] : [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.expand = false
      }
    }
  }, [_vm._v("Hide details\n        "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)]], 2), _vm._v(" "), (_vm.expand) ? [_c('v-card-text', [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "accent"
    }
  }, [_vm._v("location_on")]), _vm._v("\n        Locations\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mr-0",
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.showCreateLocation = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v("\n          New\n        ")], 1)], 1), _vm._v(" "), (_vm.service.addresses && _vm.service.addresses.length === 0) ? _c('p', {
    staticClass: "error--text"
  }, [_vm._v("\n        There are no locations for this space.\n        "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showCreateLocation = true
      }
    }
  }, [_vm._v("Create a location now")]), _vm._v(" or\n        "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = true
      }
    }
  }, [_vm._v("archive the space")]), _vm._v(" if you are no longer using it\n      ")], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showCreateLocation),
      callback: function($$v) {
        _vm.showCreateLocation = $$v
      },
      expression: "showCreateLocation"
    }
  }, [_c('location-create', {
    attrs: {
      "with-close": "",
      "space-id": _vm.service.id,
      "touch": _vm.showCreateLocation
    },
    on: {
      "save": _vm.saveAddress,
      "created": _vm.reload,
      "close": function($event) {
        _vm.showCreateLocation = false
      }
    }
  })], 1), _vm._v(" "), (_vm.globalDataLoading) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "indeterminate": "",
      "height": "2"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-expansion-panel', {
    staticClass: "elevation-1"
  }, _vm._l((_vm.service.addresses), function(address, index) {
    return _c('v-expansion-panel-content', {
      key: ("loc-s-" + (_vm.service.id) + "-" + index),
      nativeOn: {
        "click": function($event) {
          _vm.activeIndex = index
        }
      }
    }, [_c('v-list', {
      staticClass: "pa-0",
      attrs: {
        "slot": "header",
        "dense": ""
      },
      slot: "header"
    }, [(address.name) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "outline": "",
        "label": ""
      }
    }, [_vm._v(_vm._s(address.id))]), _vm._v("\n                  " + _vm._s(address.name) + "\n                  "), (_vm.service.owner_id === _vm.me.id) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "color": "primary",
        "dark": "",
        "tile": ""
      }
    }, [_vm._v("Owner")]) : _vm._e(), _vm._v(" "), (_vm.service.private) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "color": "success",
        "dark": "",
        "tile": ""
      }
    }, [_vm._v("Private")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "textContent": _vm._s(address.address)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "flat": "",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.showLocationDiaog(_vm.service, address, "assign")
              }
            }
          }, 'v-btn', attrs, false), on), [_vm._v("\n                      Assign")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Assign appointment types to this location")])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "flat": "",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.showLocationDiaog(_vm.service, address, "move")
              }
            }
          }, 'v-btn', attrs, false), on), [_vm._v("Move\n                    ")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Move this location to a different space")])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("edit")])], 1)], 1)], 1) : _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.locationComponent = "LocationEdit"
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("warning")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Please provide a name")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Click to edit")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": "",
        "text": ""
      }
    }, [_vm._v("Edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pa-2",
      attrs: {
        "md6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "100%"
      }
    }, [_c(_vm.locationComponent, {
      tag: "component",
      attrs: {
        "location": address
      },
      on: {
        "close": function($event) {
          _vm.locationComponent = "LocationView"
        },
        "save": _vm.saveAddress,
        "saved": _vm.reload,
        "edit": function($event) {
          _vm.locationComponent = "LocationEdit"
        }
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-2",
      attrs: {
        "md6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "100%"
      }
    }, [_c('v-card-title', [_c('v-subheader', {
      staticClass: "overline"
    }, [_vm._v("Operating hours")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-expansion-panel', {
      staticClass: "elevation-0",
      attrs: {
        "value": 0
      }
    }, [_vm._l((address.operation_hours_data), function(hours, index) {
      return [(_vm.getPractitionerById(hours.practitioner_id)) ? _c('v-expansion-panel-content', {
        key: hours.id,
        scopedSlots: _vm._u([{
          key: "header",
          fn: function() {
            return [(_vm.getPractitionerById(hours.practitioner_id)) ? _c('div', {
              staticClass: "subheading"
            }, [_vm._v(_vm._s(_vm.getPractitionerById(hours.practitioner_id).full_name))]) : _vm._e()]
          },
          proxy: true
        }], null, true)
      }, [_vm._v(" "), _c('v-card', [_c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('operating-hours-view', {
        attrs: {
          "lazy": "",
          "hours": hours
        },
        model: {
          value: (address.operation_hours_data[index]),
          callback: function($$v) {
            _vm.$set(address.operation_hours_data, index, $$v)
          },
          expression: "address.operation_hours_data[index]"
        }
      })], 1)], 1)], 1) : _vm._e()]
    })], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
      staticClass: "grey lighten-2"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.showLocationDiaog(_vm.service, address, "delete")
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "accent"
    }
  }, [_vm._v("star")]), _vm._v("\n        Appointment Types\n      ")], 1), _vm._v(" "), _c('product-edit', {
    on: {
      "deleted": _vm.reload,
      "saved": _vm.reload,
      "added": _vm.reload
    },
    model: {
      value: (_vm.service),
      callback: function($$v) {
        _vm.service = $$v
      },
      expression: "service"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "warning"
    }
  }, [_vm._v("warning")]), _vm._v("\n        Danger Zone")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("archive")]), _vm._v(" Archive\n      ")], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showDeleteConfirmation),
      callback: function($$v) {
        _vm.showDeleteConfirmation = $$v
      },
      expression: "showDeleteConfirmation"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.servicesArchiveRequest
    },
    on: {
      "ok": _vm.spaceArchived
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n            Archive " + _vm._s(_vm.service.title) + "?\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("What happens when I click archive")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("If this space has no appointments, it will be permanently deleted.")]), _vm._v(" "), _c('p', [_vm._v("\n            If the space has appiontments, it will be archived."), _c('br'), _vm._v("\n            An archived space is hidden from sight, but can be recovered should need be."), _c('br'), _vm._v("\n            All existing appointments in this space will remain in this space."), _c('br')])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirmation = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error",
      "loading": _vm.servicesArchiveRequest.loading
    },
    on: {
      "click": _vm.archiveSpace
    }
  }, [_vm._v("\n              Archive " + _vm._s(_vm.service.title) + "\n            ")])], 1)], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-footer', {
    staticClass: "py-0 grey lighten-2 caption",
    attrs: {
      "absolute": "",
      "bottom": ""
    }
  }, [_c('v-chip', {
    staticClass: "v-chip--x-small my-0",
    attrs: {
      "label": "",
      "outline": ""
    }
  }, [_vm._v(" #" + _vm._s(_vm.service.id))])], 1), _vm._v(" "), (_vm.selectedAddress) ? _c('v-dialog', {
    model: {
      value: (_vm.showDeleteLocation),
      callback: function($$v) {
        _vm.showDeleteLocation = $$v
      },
      expression: "showDeleteLocation"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.requests.address,
      "message204": "Address has been deleted. Reloading"
    },
    on: {
      "ok": function($event) {
        _vm.reload();
        _vm.showDeleteLocation = false
      }
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        Are you sure you want to delete " + _vm._s(_vm.selectedAddress.name) + "\n      ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteLocation = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.address.loading,
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.deleteAddress(_vm.selectedAddress.id)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSpace) ? _c('v-dialog', {
    model: {
      value: (_vm.showAssignLocation),
      callback: function($$v) {
        _vm.showAssignLocation = $$v
      },
      expression: "showAssignLocation"
    }
  }, [_c('location-assign', {
    attrs: {
      "with-close": "",
      "space": _vm.selectedSpace,
      "location": _vm.selectedAddress
    },
    on: {
      "saved": _vm.reload,
      "close": function($event) {
        _vm.showAssignLocation = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSpace) ? _c('v-dialog', {
    model: {
      value: (_vm.showMoveLocation),
      callback: function($$v) {
        _vm.showMoveLocation = $$v
      },
      expression: "showMoveLocation"
    }
  }, [_c('move-location', {
    attrs: {
      "with-close": "",
      "from-space": _vm.selectedSpace
    },
    on: {
      "close": function($event) {
        _vm.showMoveLocation = false
      },
      "setproducts": _vm.reload
    },
    model: {
      value: (_vm.selectedAddress),
      callback: function($$v) {
        _vm.selectedAddress = $$v
      },
      expression: "selectedAddress"
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f13e816","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/SpaceSettings.vue
// module id = 1326
// module chunks = 9